import { Alert, AlertDescription, AlertTitle } from "@ui/components/alert";
import { MailCheckIcon } from "lucide-react";

export function OrganizationInvitationAlert({
	className,
}: {
	className?: string;
}) {
	return (
		<Alert className={className}>
			<MailCheckIcon className="text-brand!" />
			<AlertTitle>You've been invited to a team</AlertTitle>
			<AlertDescription>
				Sign in first. You'll accept the invitation on the next screen.
			</AlertDescription>
		</Alert>
	);
}
